import React, { useEffect, useState } from "react";
import { IonToggle, IonLabel, IonIcon, IonItem, IonText } from "@ionic/react";
import { iconsMenu } from "../Menu/IconData";

type Option = string;

interface ToggleABMMenuProps {
  options?: Option; 
  onSelectionChange?: (selected: string[]) => void;
  onIconSelect?: (iconName: string) => void;
  initialSelected?: string[];
  initialSelectedIcon?: string;
}

const textOptions = ["BANCOS", "RETAIL", "INTERNO", "ADMIN", "SWT"];

const ToggleABMMenu: React.FC<ToggleABMMenuProps> = ({
  options,
  onSelectionChange,
  onIconSelect,
  initialSelected = [],
  initialSelectedIcon = null,
}) => {
  const isCategoryMode = options === "categoria";
  const isTextMode = Array.isArray(options) || isCategoryMode;

  const items = isCategoryMode
    ? textOptions.map(label => ({ label }))
    : Array.isArray(options)
      ? options.map(label => ({ label }))
      : iconsMenu.icons;

  const [selectedSet, setSelectedSet] = useState<Set<string>>(new Set(initialSelected));
  const [selectedIcon, setSelectedIcon] = useState<string | null>(initialSelectedIcon);

  useEffect(() => {
    if (isTextMode) {
      setSelectedSet(new Set(initialSelected));
    } else {
      setSelectedIcon(initialSelectedIcon);
    }
  }, [initialSelected.join(','), initialSelectedIcon]);

  const toggleTextSelected = (label: string) => {
    const newSet = new Set(selectedSet);
    if (newSet.has(label)) {
      newSet.delete(label);
    } else {
      newSet.add(label);
    }
    setSelectedSet(newSet);
    onSelectionChange?.(Array.from(newSet));
  };

  const selectIcon = (label: string) => {
    const newValue = label === selectedIcon ? null : label;
    setSelectedIcon(newValue);
    if (newValue) {
      onIconSelect?.(newValue);
    }
  };

  return (
    <div className="abmmenu-toggle-contendor">
      {items.map((item, index) => {
        const label = "label" in item ? item.label : item.title;
        const iosIcon = "iosIcon" in item ? item.iosIcon : undefined;
        const mdIcon = "mdIcon" in item ? item.mdIcon : undefined;

        return (
          <IonItem key={index} lines="none">
            {iosIcon && mdIcon && (
              <IonIcon className="abmmenu-toggle-img" slot="start" ios={iosIcon} md={mdIcon} />
            )}
            {isTextMode && <IonText>{label}</IonText>}
            <IonToggle
              color="secondary"
              checked={isTextMode ? selectedSet.has(label) : selectedIcon === label}
              className="abmmenu-toggle"
              onIonChange={() =>
                isTextMode ? toggleTextSelected(label) : selectIcon(label)
              }
            />
          </IonItem>
        );
      })}
    </div>
  );
};

export default ToggleABMMenu;
